import { MouseEvent } from 'react'
import { IWishlistButtonProps } from '@awazevr/design-system.compositions.property-card'
import { WishlistButton } from '@awazevr/design-system.components.wishlist-button'
import { StyledWishlistButtonContainer } from './Wishlists.styles'

export type WishlistsProps = {
  label?: string
  wishlistButton?: IWishlistButtonProps
}

const defaultWishlistButton: IWishlistButtonProps = {
  showWishlistButton: false,
  isPropertyInWishlist: false,
  toggleWishlistItem: () => {},
}

export const Wishlists = ({
  label,
  wishlistButton = defaultWishlistButton,
}: WishlistsProps) => {
  if (!wishlistButton.showWishlistButton) return null

  const stopCardClick = (e: MouseEvent<HTMLDivElement>) => {
    e.stopPropagation()
    e.preventDefault()
  }

  return (
    <StyledWishlistButtonContainer role="presentation" onClick={stopCardClick}>
      <WishlistButton
        label={label ?? ''}
        isChecked={wishlistButton.isPropertyInWishlist}
        showLabel={false}
        variant="elevated"
        buttonSize={wishlistButton.buttonSize}
        throttleDuration={wishlistButton.throttleDuration}
        onClickCallback={wishlistButton.toggleWishlistItem}
      />
    </StyledWishlistButtonContainer>
  )
}
